<template>
  <div class="view-payments py-4">
    <h4 class="mb-5 text-primary-light">{{ $t("suporte") }}</h4>
    <div class="container">
      <div class="p-4 shadow d-flex align-items-center mb-5">
        <i class="icon-whatsapp"></i>
        <a
          class="btn btn-link"
          href="https://wa.me/message/NZSZPPNJRYF2B1"
          target="_blank"
        >
          {{ $t("solicitarAtendimento") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
